import { GridList, GridListTile, GridListTileBar, IconButton, makeStyles } from '@material-ui/core'
import React, { useState } from 'react'
import { isMobile } from 'react-device-detect'
import DeleteIcon from '@material-ui/icons/Delete'
import EditIcon from '@material-ui/icons/Edit'

const useStyles = makeStyles(theme => ({
    root: {
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "space-around",
        overflow: "hidden",
        paddingTop: "7px",
        paddingBottom: "20px"
    },
    titleBar: {
        background:
            "linear-gradient(to bottom, rgba(0,0,0,0.7) 0%, " +
            "rgba(0,0,0,0.3) 70%, rgba(0,0,0,0) 100%)"
    },
    titleBarBottom: {
        background:
            "linear-gradient(to top, rgba(0,0,0,0.7) 0%, " +
            "rgba(0,0,0,0.3) 70%, rgba(0,0,0,0) 100%)"
    }
}));

export default function Gallery ({
    tileData,
    cols = 4,
    cellHeight = 300,
    spacing = 7,
    colsMobile = 2,
    cellHeighMobile = 200,
    spacingMobile = 7,
    onDelete = null,
    onEdit = null,
    onSelect = null,
    onUnSelect = null,
    onClick = null
}) {
    const classes = useStyles();
    const [ isSelected, setIsSelected ] = useState({})
    const mediatoken = localStorage.getItem('mediatoken');
    /**
     * Função toggle de seleção
     *
     * @param {*} event
     * @param {*} data
     */
    const handleSelect = ( event, data ) => {
        if ( onSelect && onUnSelect ) {
            const name = data.id;
            isSelected[data.id] ? onSelect(event, data ) : onUnSelect(event, data )
            setIsSelected({
                ...isSelected,
                [name]: !isSelected[name]
            })
        }
    }

    /**
     * Função do botão de editar
     *
     * @param {*} event
     * @param {*} data
     */
    const handleEdit = (event, data) => {
        onEdit && onEdit(event, data)
    }

    /**
     * Função do botão de Apagar
     *
     * @param {*} event
     * @param {*} data
     */
    const handleDelete = (event, data) => {
        onDelete && onDelete(event, data)
    }

    return (
        <div className={classes.root}>
            <GridList
                cols={isMobile ? colsMobile : cols}
                cellHeight={ isMobile ? cellHeighMobile : cellHeight}
                spacing={isMobile ? spacingMobile : spacing}
                className="w-100 h-100"
            >
                {tileData.map((tile, index) => (
                    <GridListTile
                        key={tile.id}
                        cols={1}
                        rows={1}
                        onClick={(event) => (onClick && onClick(tile.photo + '?' + mediatoken))}
                        className={`cursor-pointer ${isSelected[tile.id] ? 'border border-4 border-primary': ''}`}
                    >
                        <img
                            src={tile.photo + '?' + mediatoken}
                            alt={tile.name}
                            onClick={(event) => (handleSelect(event, tile))}
                        />
                        <GridListTileBar
                            title={tile.name}
                            titlePosition="top"
                            className={classes.titleBar}
                        />
                        <GridListTileBar
                            titlePosition="bottom"
                            actionIcon={
                                <>
                                    { onEdit && <IconButton
                                        className="text-white text-hover-primary"
                                        onClick={(event) => ( handleEdit(event, tile) )}
                                    >
                                        <EditIcon />
                                    </IconButton> }
                                    { onDelete && <IconButton
                                        className="text-light-danger text-hover-danger"
                                        onClick={(event) => ( handleDelete(event, tile) )}
                                    >
                                        <DeleteIcon />
                                    </IconButton> }
                                </>
                            }
                            className={classes.titleBarBottom}
                        />
                    </GridListTile>
                ))}
            </GridList>
        </div>
    )
}
